import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLiveRipple = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			opacity: .25,
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#A7F3D0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 4.75,
			fill: "#10B981",
			stroke: "#A7F3D0",
			strokeWidth: 2.5
		})
	]
});
const ForwardRef = forwardRef(SvgIconLiveRipple);
export { ForwardRef as ReactComponent };
